export default __webpack_public_path__ + "locales/lv/SharingPanel.json?hash=11a1abbac1b56903fc41074b710eadd9";